<template>
  <div class="prose max-w-none">
    <h2 class="text-3xl font-bold mb-6">{{ name }}</h2>
    <p class="text-lg mb-4">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProgramDescription',
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script> 